import React from 'react';
import { graphql } from 'gatsby';
import PricingPage from 'components/pages/PricingPage';

const seo = {
  title: 'Q°emotion – Tarifs et abonnements',
  keywords: [],
  description:
    'Payez peu et gagnez beaucoup. Améliorez votre expérience client grâce à Q°emotion à un prix correspondant à vos besoins. Abonnement mensuels ou annuels. Test gratuit.',
};

export default props => <PricingPage seo={seo} {...props} />;

export const pageQuery = graphql`
  query {
    dataSyntheticPricing: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "syntheticPricingBlock" }
          lang: { eq: "fr" }
          name: { ne: "Emotion Plus"}
        }
      }
    ) {
      nodes {
        frontmatter {
          index
          name
          benchmarkCount
          billedAnnualPrice
          categoriesMax
          commentsPerMonth
          commentsPerYear
          customerJourney
          dataCollection
          isCorporate
          liveSupport
          pricePerComment
          supportPriority
          reportingCount
          userCount
          annualPrice
          monthlyPrice
        }
      }
    }
    dataDetailedPricing: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "detailedPricingBlock" }
          lang: { eq: "fr" }
          name: { ne: "Emotion Plus" }
        }
      }
    ) {
      nodes {
        frontmatter {
          index
          name
          pricePerComment
          monthlyPrice
          annualPrice
          billedAnnualPrice
          commentsPerYear
          commentsPerMonth
          categoriesMax
          customerJourney
          dataCollection
          automatedScheduler
          generalModules
          customerJourneyModule
          emotionalMapping
          alertModule
          insightModule
          benchmarkCount
          reportingCount
          userCount
          resultsDelivery
          fileImport
          fileSpecs
          yourSurveys
          tripadvisor
          googleMyBusiness
          amazonReviews
          otherWebReviews
          zendesk
          emails
          chatConversations
          socialNetworks
          blogs
          liveSupport
          helpCenter
          ticketsPriority
        }
      }
    }
    dataQuestionsFaqBlock: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "faqBlock" }
          lang: { eq: "fr" }
          index: { gte: 1 }
        }
      }
      sort: { fields: [frontmatter___index] }
    ) {
      nodes {
        rawMarkdownBody
        html
        frontmatter {
          title
        }
      }
    }
    dataFooterFaqBlock: markdownRemark(
      frontmatter: {
        pageType: { eq: "pricing" }
        blockType: { eq: "faqBlock" }
        lang: { eq: "fr" }
        index: { eq: 0 }
      }
    ) {
      html
    }
    dataBlockLinkBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "linkBlock" }
          lang: { eq: "fr" }
        }
      }
      sort: { fields: [frontmatter___idBlock] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          subTitle
          color
          link
          buttonText
        }
      }
    }
  }
`;
